// Thin entry point: only decides *whether* to load the 3D view, never
// touches three.js itself. Keeping this file import-light means visitors
// without WebGL (or without cluster data) never trigger the dynamic
// import below, and the ~real~ scene module — which does the heavy static
// `import "three"` — only downloads once we know it's actually needed. The
// server-rendered project grid in #home-fallback stays visible the whole
// time this hasn't resolved yet, so there's no blank state either way.
const dataEl = document.getElementById("cluster-data");
const mount = document.getElementById("constellation-mount");

function supportsWebGL() {
  try {
    const canvas = document.createElement("canvas");
    return !!(canvas.getContext("webgl2") || canvas.getContext("webgl"));
  } catch {
    return false;
  }
}

if (dataEl && mount && supportsWebGL()) {
  const { imageNodes, sceneRadius } = JSON.parse(dataEl.textContent);
  if (imageNodes.length > 0) {
    const { init } = await import("./constellation-scene.js");
    init(mount, imageNodes, sceneRadius);
  }
}
